export default {"src":"/_next/static/media/kale.fb5e7808.svg","height":39,"width":73,"blurWidth":0,"blurHeight":0};